/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterL = createReactComponent("outline", "letter-l", "IconLetterL", [["path", { "d": "M7 4v16h10", "key": "svg-0" }]]);

export { IconLetterL as default };
//# sourceMappingURL=IconLetterL.mjs.map
